import * as UAParser from 'ua-parser-js';

let currentDeviceType: 'mobile' | 'tablet' | 'desktop' | null = null;

export function deviceTypes() {
  if (currentDeviceType !== null) {
    return currentDeviceType;
  }
  const device = new UAParser().getDevice();
  if (device.type === 'mobile') {
    currentDeviceType = 'mobile';
  } else if (device.type === 'tablet') {
    currentDeviceType = 'tablet';
  } else {
    currentDeviceType = 'desktop';
  }

  return currentDeviceType;
}
